import Vue from 'vue';

import Router from 'vue-router';
import RouterPrefetch from 'vue-router-prefetch';
import Meta from 'vue-meta';

import Home from './views/Home.vue';

Vue.use(Router);
Vue.use(RouterPrefetch);
Vue.use(Meta);

const router = new Router({
    base: process.env.BASE_URL,

    mode: 'history',

    scrollBehavior(to, from, savedPosition) {
        if (to.name === 'Profile') {
            return;
        }
        if (savedPosition) {
            return savedPosition;
        } else {
            return {x: 0, y: 0};
        }
    },

    routes: [
        {
            path: '/',
            alias: '*',
            name: 'Home',
            component: Home,
            children: [
                {
                    // при совпадении пути с шаблоном /user/:id/profile
                    // в <router-view> компонента User будет показан UserProfile
                    name: 'Profile',
                    path: 'profile/:id',
                    component: () => import(/* webpackChunkName: "missblock" */ './views/Missblock.vue')
                }
            ]
        },
        {
            path: '/pd',
            name: 'PartisipantData',
            component: () => import(/* webpackChunkName: "partisipantdata" */ './views/PartisipantData.vue')
        },
        {
            path: '/ld',
            name: 'LogsData',
            component: () => import(/* webpackChunkName: "logsdata" */ './views/LogsData.vue')
        }
    ]
});

export default router;
